module.exports = __webpack_public_path__ + "img/act-desc.93aa18a3.png";